module.exports = __webpack_public_path__ + "img/promotion_1.3a83ffd0.png";